import _ from 'lodash'
import Mustache from 'mustache'
import riderMessages from 'core/data-model/constants/validation-messages'
import { formatNumber } from 'core/service/lib/number-format'

export const checkSumAssuredTiersRule = (rule, eligibilities) => {
  let errorMessage = ''

  const tier = findSumAssuredTier(rule.tiers, eligibilities.basicSumAssured)
  if (tier && eligibilities.rider.sumAssured > tier.maximumRiderSumAssured) {
    errorMessage = Mustache.render(riderMessages.RULE_RIDER_SUM_ASSURED_TIERS, {
      minimumBasicSumAssured: formatNumber(tier.minimumBasicSumAssured),
      maximumBasicSumAssured: formatNumber(tier.maximumBasicSumAssured),
      maximumRiderSumAssured: formatNumber(tier.maximumRiderSumAssured),
    })
  }

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}

const findSumAssuredTier = (tiers, basicSumAssured) => {
  return _(tiers)
    .chain()
    .find(
      ({ minimumBasicSumAssured, maximumBasicSumAssured }) =>
        Math.floor(basicSumAssured) >= minimumBasicSumAssured && Math.floor(basicSumAssured) <= maximumBasicSumAssured
    )
    .value()
}
